import { render } from "./NewsCarousel.vue?vue&type=template&id=9fbdf27e&scoped=true"
import script from "./NewsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&lang=js"

import "./NewsCarousel.vue?vue&type=style&index=0&id=9fbdf27e&scoped=true&lang=css"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fbdf27e"]])

export default __exports__